export const isArray = data => {
  if (Array.isArray(data)) return true;

  return false;
};
